import { STEPPER_STEP_STATE } from './constants';

// Accepts the DS step shape `{ id, label, icon, invalid }` and the JEV tab shape (same keys).
export const normalizeSteps = (steps) =>
    (Array.isArray(steps) ? steps : [])
        .filter((step) => step && step.id != null)
        .map((step) => ({
            id: step.id,
            label: step.label ?? '',
            icon: step.icon ?? null,
            invalid: Boolean(step.invalid),
        }));

export const stepState = (index, activeIndex) => {
    if (index === activeIndex) return STEPPER_STEP_STATE.ACTIVE;
    if (activeIndex > -1 && index < activeIndex) return STEPPER_STEP_STATE.COMPLETED;
    return STEPPER_STEP_STATE.UPCOMING;
};
